export default __webpack_public_path__ + "static/media/patient.3d87bba3.jpeg";